import { useLocation } from 'react-router';

// Lightweight helper to get a typed location.state without casting to `any` everywhere.
// Returns the location object narrowed to have an optional typed `state` property.
function useTypedLocation<TState>(): { state?: TState | undefined } & ReturnType<typeof useLocation> {
    return useLocation() as unknown as { state?: TState | undefined } & ReturnType<typeof useLocation>;
}

export default useTypedLocation;
